import React from "react";
import { Space, Spin } from "antd";

export const Container = (props: ContainerProps) => {
  const { loading, children, paddingClass, innerClassName, leftClassName } =
    props;

  return (
    <div className={` ${paddingClass} `}>
      <div>
        <Spin spinning={loading ?? false}>
          <>
            <div className="d-flex flex-column bg-gray rounded px-2">
              {/* Main action buttons row */}
              {props.toolbarItems?.start?.length && (
                <div
                  className={`d-flex flex-row align-items-center justify-content-start flex-wrap w-100 ${leftClassName} py-2`}
                >
                  <Space wrap className="btn-group-responsive">
                    {props.toolbarItems.start.map((component) => (
                      <React.Fragment key={Math.random()}>
                        {component}
                      </React.Fragment>
                    ))}
                  </Space>
                </div>
              )}

              {/* Navigation buttons row */}
              {props.toolbarItems?.navigation?.length && (
                <div className="d-flex flex-row align-items-center justify-content-end w-100 py-2 border-top">
                  <Space wrap>
                    {props.toolbarItems.navigation.map((component) => (
                      <React.Fragment key={Math.random()}>
                        {component}
                      </React.Fragment>
                    ))}
                  </Space>
                </div>
              )}

              {/* End items (keeping for backward compatibility) */}
              {props.toolbarItems?.end?.length && (
                <div className="d-flex flex-row align-items-center justify-content-end py-2">
                  <Space wrap>
                    {props.toolbarItems.end.map((component) => (
                      <React.Fragment key={Math.random()}>
                        {component}
                      </React.Fragment>
                    ))}
                  </Space>
                </div>
              )}
            </div>
            <div className={innerClassName}>{children}</div>
          </>
        </Spin>
      </div>
    </div>
  );
};

export interface ContainerProps {
  children: React.ReactNode;
  loading?: boolean;
  paddingClass?: string;
  innerClassName?: string;
  toolbarItems?: {
    start?: React.ReactNode[];
    navigation?: React.ReactNode[];
    end?: React.ReactNode[];
  };
  leftClassName?: string;
}
